// extracted by mini-css-extract-plugin
export default {"ColumnHeaders":"ColumnHeaders__cEl1ChnK72Z2","HeaderCell":"HeaderCell__tfsnvQweaUml","HeaderCellNoSort":"HeaderCellNoSort__MuMxhIecut01"};